// extracted by mini-css-extract-plugin
export default {"product":"rodrailShop_product__h0j3T","like":"rodrailShop_like__+xfh1","collect-box":"rodrailShop_collect-box__xLYYe"};